/*
SOURCE:
https://github.com/Shivanik97/msal-auth-vue/
https://medium.com/@kuntumallashivani/a-guide-to-msal-3-0-authentication-in-vue-3-8c364cc26f53
*/

import {
  ref,
  toRef,
  toRefs,
  computed,
  defineComponent,
  watch,
  reactive,
  onMounted,
  inject,
  onUnmounted,
  provide,
} from "vue"
import { PublicClientApplication } from "@azure/msal-browser"

const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: AUTHORITY,
    redirectUri: `${REDIRECT_URI}`,
    postLogoutRedirectUri: `${REDIRECT_URI}`,
  },
  cache: {
    cacheLocation: "localStorage",
    storeAuthStateInCookie: false,
  },
}

export const loginRequest = {
  // "openid", "profile",
  scopes: [],
  // extraQueryParameters: { ui_locales: LOCALE }
}

export const getSilentRequest = (account) => ({
  scopes: [API_SCOPE],
  account,
})

export const graphScopes = {
  scopes: ["openid", "profile", "email"],
}

export const msalInstance = new PublicClientApplication(msalConfig)
